import { render, staticRenderFns } from "./CommentStatus.vue?vue&type=template&id=74944945"
import script from "./CommentStatus.vue?vue&type=script&lang=js"
export * from "./CommentStatus.vue?vue&type=script&lang=js"
import style0 from "./CommentStatus.vue?vue&type=style&index=0&id=74944945&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports